export const titles = [
    { name: 'Mr' },
    { name: 'Mrs' },
    { name: 'Miss' },
    { name: 'Dr' },
    { name: 'Rev' },
    { name: 'Prof' },
];